<script setup>
import { Collapse } from 'vue-collapsed';

const props = defineProps({
  title: {
    type: String,
    default: undefined,
  },
  text: {
    type: String,
    default: undefined,
  },
  isOpenedOutside: {
    type: Boolean,
    default: undefined,
  },
});

const emit = defineEmits(['toggle']);

const localOpened = ref(false);

const isOpened = computed(() => props.isOpenedOutside ?? localOpened.value);

function toggle() {
  const next = !isOpened.value;

  emit('toggle', next);

  if (props.isOpenedOutside === undefined) {
    localOpened.value = next;
  }
}

const { tp } = useTypograf();
</script>

<template>
  <div class="ui-toggle" :class="{ 'ui-toggle--opened': isOpened }">
    <div class="ui-toggle__head" @click="toggle">
      <div class="ui-toggle__title">
        <span
          class="ui-toggle__font ui-toggle__font--title"
          v-html="tp(title)"
        />
      </div>

      <CIcon name="chevron-down" class="ui-toggle__icon" />
    </div>

    <Collapse :when="isOpened" class="ui-toggle__toggle">
      <slot>
        <div class="ui-toggle__text">
          {{ text }}
        </div>
      </slot>
    </Collapse>
  </div>
</template>

<style scoped lang="scss">
.ui-toggle {
  $parent: &;

  &__font {
    &--title {
      font-size: em(18);
      font-weight: 400;
      line-height: math.div(24, 18);

      @include media-breakpoint-mobile {
        font-size: em(16);
        line-height: 1.2;
        font-weight: $font-weight-medium;
      }
    }

    &--text {
      font-size: em(18);
      font-weight: 300;
      line-height: math.div(24, 18);

      @include media-breakpoint-down(sm) {
        font-size: em(16);
        font-weight: 300;
        line-height: math.div(22, 16);
      }
    }
  }

  &__icon {
    @include box(em(28));

    flex-shrink: 0;
    margin-inline-start: em(20);
    color: $color-gray-23;
    transition: transform $time-2;
  }

  &__head {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }

  &__toggle {
    transition: height $time-7;
  }

  &__text {
    padding-bottom: em(22);
  }

  &--opened {
    #{$parent} {
      &__icon {
        color: $color-main-5;
        transform: rotate(180deg);
      }
    }
  }
}
</style>
